import './index.scss';
import React, { ChangeEventHandler, useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon } from '@fortawesome/free-solid-svg-icons';
import { faSunBright } from '@fortawesome/pro-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const DarkLightMode = () => {
  const setDark = useCallback(() => {
    localStorage.setItem('theme', 'dark');
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  const setLight = useCallback(() => {
    localStorage.setItem('theme', 'light');
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  const storedTheme = localStorage.getItem('theme');

  const defaultDark = storedTheme === 'dark';

  defaultDark ? setDark() : setLight();

  const [isDarkMode, setIsDarkMode] = useState(defaultDark);

  const toggleTheme = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      if (event.target.checked) {
        setLight();
      } else {
        setDark();
      }
      setIsDarkMode((prev) => !prev);
    },
    [setDark, setLight]
  );

  return (
    <div className="toggle-theme-wrapper">
      <label className="toggle-theme" htmlFor="checkbox">
        <input
          type="checkbox"
          id="checkbox"
          checked={!isDarkMode}
          onChange={toggleTheme}
        />
        <div className="slider round"></div>
        {isDarkMode ? (
          <FontAwesomeIcon className="moon" icon={faMoon} fontSize={20} />
        ) : (
          <FontAwesomeIcon
            className="sun"
            icon={faSunBright as IconProp}
            fontSize={20}
          />
        )}
      </label>
    </div>
  );
};

export default DarkLightMode;
